import axios from "axios";
import ecSite from "@/common/site";
import notify from "@/common/hx-notify";
import router from "@/router";
import HxMessage from "@/common/hx-message";
import sessionUtils from "@/utils/session-store-utils";

axios.defaults.timeout = 3000000;
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

let TEST_OR_PRODUCT = 2; // 加密开关 1测试 2正式环境
let getjm = 1; // get请求加密开关 1测试 2正式环境
let resbody = 2; //交易返回内容解密开关  1测试 2正式环境
if (process.env.NODE_ENV === "production") {
  TEST_OR_PRODUCT = 2;
  resbody = 2;
}

//获取当前秒数
function getTimes() {
  // 获取当前时间，单位是毫秒，精度到微秒
  const timeInMilliseconds = new Date().getTime();
  // 将时间转换为秒
  const timeInPicoseconds = Math.floor(timeInMilliseconds / 1000);
  return timeInPicoseconds;
  // 1 毫秒 = 10^9 皮秒 this.timeInPicoseconds = timeInPicoseconds;
}
// 请求列表(防重复提交)
let requestList = [];
//需要重复提交判断的api地址
let jlist = [
  "/page/editUser",
  "/page/submitVolunteer",
  "/business/BPageSecondaryVocational/add",
];
let cancelToken = axios.CancelToken;

axios.interceptors.request.use(
  (config) => {
    // config.headers.zsylogin = JSON.parse(sessionStorage.getItem("token"));
    // config.headers.membersId = JSON.parse(sessionStorage.getItem("membersId"));
    config.cancelToken = new cancelToken((cancel) => {
      let requestFlag =
        JSON.stringify(config.url) +
        JSON.stringify(config.data) +
        "&" +
        config.method +
        getTimes();
      // console.log(!jlist.includes(config.url));
      // console.log(config.url);
      // console.log(requestList);
      if (jlist.includes(config.url)) {
        if (requestList.includes(requestFlag)) {
          //请求标记已经存在，则取消本次请求，否则在请求列表中加入请求标记
          cancel("取消本次请求"); //取消本次请求
          // requestList.splice(index, 1);
          // console.log(requestList);
        } else {
          requestList.push(requestFlag);
          config.headers.MseeCheck = JSON.parse(
            sessionStorage.getItem("token")
          );
          config.headers.time = getTimes();
          if (JSON.parse(sessionStorage.getItem("time"))) {
            const time = JSON.parse(sessionStorage.getItem("time"));
            if (new Date().getTime() > time) {
              sessionStorage.clear();
              notify.error("登录信息失效，请重新登录!");
              router.push("/login");
            } else {
              const times = new Date().getTime() + 30 * 60 * 1000;
              sessionStorage.setItem("time", JSON.stringify(times));
            }
          }

          if (TEST_OR_PRODUCT !== 1) {
            // console.log(config);
            if (config.method == "post") {
              config.data = ecSite.encryptByDES(config.data);
            } else if (config.method == "get") {
              if (config.url.indexOf("?") != -1 && getjm == 2) {
                //如果字符转包含了*符号
                const a = config.url.split("?")[1];
                let b = "";
                console.log(a); //则取*号之后的
                b = ecSite.encryptByDES(a);
                config.url = config.url.replace(
                  a,
                  "bodyContent=" + b.bodyContent
                );
              } else {
                // console.log("不好意思，当前字符串没有该字符");
              }
            } else {
              return notify.error("提示", "请求方式异常");
            }
          }
        }
      } else {
        config.headers.MseeCheck = JSON.parse(sessionStorage.getItem("token"));
        config.headers.time = getTimes();
        if (JSON.parse(sessionStorage.getItem("time"))) {
          const time = JSON.parse(sessionStorage.getItem("time"));
          if (new Date().getTime() > time) {
            sessionStorage.clear();
            notify.error("登录信息失效，请重新登录!");
            router.push("/login");
          } else {
            const times = new Date().getTime() + 30 * 60 * 1000;
            sessionStorage.setItem("time", JSON.stringify(times));
          }
        }
        // console.log(config);
        if (TEST_OR_PRODUCT !== 1) {
          // console.log(config);
          if (config.method == "post") {
            config.data = ecSite.encryptByDES(config.data);
          } else if (config.method == "get") {
            if (config.url.indexOf("?") != -1 && getjm == 2) {
              //如果字符转包含了*符号
              const a = config.url.split("?")[1];
              let b = "";
              console.log(a); //则取*号之后的
              b = ecSite.encryptByDES(a);
              config.url = config.url.replace(
                a,
                "bodyContent=" + b.bodyContent
              );
            } else {
              // console.log("不好意思，当前字符串没有该字符");
            }
          } else {
            return notify.error("提示", "请求方式异常");
          }
        }
      }

      // 登录流程控制中，根据本地是否存在token判断用户的登录情况
      // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
      // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
      // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
    });

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (response) => {
    // 响应解密
    if (
      (response.msg && response.msg == "token过期，请重新登录！") ||
      (response.data.msg && response.data.msg == "token过期，请重新登录！")
    ) {
      console.log(response);
      router.replace({ name: "login" });
      console.log(JSON.parse(sessionStorage.getItem("token")));
      if (JSON.parse(sessionStorage.getItem("token")) != null) {
        sessionUtils.logout();
        sessionStorage.clear();
        HxMessage.error("登录信息失效，请重新登录");
      }
    } else {
      if (resbody == 2) {
        if (response.data.data != undefined) {
          response.data.data = JSON.parse(
            ecSite.decryptByDES(response.data.data)
          );
        }
        if (response.data.rows != undefined) {
          response.data.rows = JSON.parse(
            ecSite.decryptByDES(response.data.rows)
          );
        }
      }
    }
    return response.data;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 404:
          notify.error("请求的资源不存在");
          break;
        default:
          notify.error("请求响应异常");
          break;
      }
    } else if (error.message == "取消本次请求") {
      console.log("重复提交，取消本次请求");
    } else {
      notify.error("网络异常");
    }
    return Promise.reject(error);
  }
);

export default axios;
